define([
	"./_Color",
	"./PluginFactory"
], function(_Color, PluginFactory) {

	return PluginFactory.declare(_Color, {
		"class": "csi-color-icon csi-text-formatting-select-button-no-border",
		bSupportTransparent: false,
		bText: true,
		cssStyle: "color",
		materialIcon: "format_color_text",
		pluginName: "textColor",
		title: "CanvasTextColor"
	});
});
